import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import DominioTipoForm from './components/formDominioTipo';
import {
  headersTiposDominio,
  valoresExibidosDominiosTipos,
} from './utils/auxiliarTipo';
import BoxConteudo from '../../../../../../components/BoxConteudo';
import CustomButton from '../../../../../../components/CustomButton';
import CustomCol from '../../../../../../components/CustomCol';
import CustomRow from '../../../../../../components/CustomRow';
import Tabela from '../../../../../../components/Tabela';
import { getUser } from '../../../../../../modules/contexts/Auth/RequireAuth';
import { ICorRegistro } from '../../../../../../modules/types/Cor';
import { getAllCores } from '../../../../../../services/cores/corService';
import { getDominiosByPaiId } from '../../../../../../services/dominio/dominioService';
import theme from '../../../../../../theme';
import {
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../../../utils/functions';
import { optionStatusBin } from '../../utils/optionStatusBin';

export default function DominioTipo() {
  const params = useParams();
  const dominioId = Number(params.id);

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [novoDominioTipo, setNovoDominioTipo] = useState(false);
  const handleClickInserirNovoDominioTipo = () => {
    setSelectedId(null);
    setNovoDominioTipo(true);
    setShowOffcanvas(true);
  };

  //////FETCH DATA
  const [data, setData] = useState<any[]>([]);
  const fetchData = async () => {
    try {
      const lista = await getDominiosByPaiId(dominioId);
      setData(Array.isArray(lista) ? lista : []);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  //////TABLE E OFFCANVAS
  const tableData =
    data?.map((item) => {
      return {
        id: item.id,
        status: (
          <span
            style={{
              backgroundColor:
                item.status === 1
                  ? theme.colors.verdegov
                  : theme.colors.vermelho,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              minWidth: '70px',
              textAlign: 'center',
              color: 'white',
            }}
          >
            {optionStatusBin[item.status]?.label}
          </span>
        ),
        ordem: (
          <span
            style={{
              padding: '12px',
              display: 'inline-block',
              minWidth: '50px',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
            }}
          >
            {item.ordem}º
          </span>
        ),
        nome: (
          <span
            style={{
              backgroundColor: item.cor.codigoHexadecimal
                ? item.cor.codigoHexadecimal
                : '#FFFFFF',
              color: item.corText === 2 ? 'white' : 'black',
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              minWidth: '100px',
              textAlign: 'left',
            }}
          >
            {item.nome}
          </span>
        ),
        descricao: item.descricao ? item.descricao : '—',
      };
    }) || [];

  const offCanvasData =
    data?.map((item) => {
      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        status: (
          <span
            style={{
              backgroundColor:
                item.status === 1
                  ? theme.colors.verdegov
                  : theme.colors.vermelho,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              minWidth: '70px',
              textAlign: 'center',
              color: 'white',
            }}
          >
            {optionStatusBin[item.status]?.label}
          </span>
        ),
        ordem: (
          <span
            style={{
              padding: '12px',
              display: 'inline-block',
              fontWeight: 'bold',
              fontSize: '14px',
            }}
          >
            {item.ordem}º
          </span>
        ),
        nome: (
          <span
            style={{
              backgroundColor: item.cor.codigoHexadecimal,
              color:
                item.corText === 2 ? theme.colors.white : theme.colors.black,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              minWidth: '100px',
              textAlign: 'center',
            }}
          >
            {item.nome}
          </span>
        ),
        descricao: item.descricao ? item.descricao : 'Não informado',
        separadorCores: '',
        corId: item.cor.id,
        corCodigo: item.cor.codigoHexadecimal,
        corNome: item.cor ? (
          <span
            style={{
              color: item.cor.codigoHexadecimal,
              fontWeight: 'bold',
            }}
          >
            {item.cor.nomeCor}
          </span>
        ) : (
          ''
        ),
        corText:
          item.corText === 1 ? 'Black' : item.corText === 2 ? 'White' : '',

        separadorObservacoes: '',
        observacoes: item.observacoes || 'Sem observações.',
      };
    }) || [];

  const [selectedId, setSelectedId] = useState<number | null>(null);
  const handleRowClick = (id: number) => {
    setSelectedId(id);
    setNovoDominioTipo(false);
    setShowOffcanvas(true);
  };

  const [allCores, setAllCores] = useState<ICorRegistro[]>([]);
  const [optionsCores, setOptionsCores] = useState<
    { value: number; label: string }[]
  >([]);

  useEffect(() => {
    async function loadCores() {
      const cores = await getAllCores();
      setAllCores(cores);

      const opts = [
        { value: 0, label: 'Não informado' }, // 🔹 Adicionado aqui
        ...cores
          .sort((a, b) => a.nomeCor.localeCompare(b.nomeCor))
          .map((cor) => ({
            value: cor.id,
            label: cor.nomeCor,
          })),
      ];

      setOptionsCores(opts);
    }

    loadCores();
  }, []);

  return (
    <>
      <BoxConteudo boxTitulo="Tipos do Domínio">
        <CustomRow>
          <CustomCol width="100%">
            <Tabela
              headers={headersTiposDominio}
              dataTable={tableData}
              displayValues={valoresExibidosDominiosTipos}
              onRowClick={handleRowClick}
              dataOffCanvas={offCanvasData}
              botaoAbrirOffCanvas={false}
              showPagination={false}
            />
          </CustomCol>
        </CustomRow>
        <CustomCol className="d-flex justify-content-end gap-3">
          <CustomButton
            label="Novo Tipo de Domínio"
            bgColor={theme.colors.botaoAcao.azul}
            textColor={theme.colors.white}
            onClick={() => {
              handleClickInserirNovoDominioTipo();
            }}
          />
        </CustomCol>

        {/* Offcanvas /*/}
        <DominioTipoForm
          show={showOffcanvas}
          onHide={() => setShowOffcanvas(false)}
          novoDominioTipo={novoDominioTipo}
          selectedId={selectedId}
          allCores={allCores}
          optionsCores={optionsCores}
          recarregarDados={fetchData}
          listaOrdemsExistentes={data.map((d) => d.ordem)}
        />
      </BoxConteudo>
    </>
  );
}
